import { onBeforeMount, onUnmounted } from 'vue';
import { $gettext } from '../../assets/javascripts/lib/gettext';
let instances = [];
let isGlobalHandlerRegistered = false;
function securityHandler(event) {
    if (instances.some((instance) => instance.shouldWarn())) {
        event.preventDefault();
        event.returnValue = $gettext('Ihre Eingaben wurden bislang noch nicht gespeichert.');
        return event.returnValue;
    }
}
function registerGlobalHandler() {
    if (!isGlobalHandlerRegistered) {
        window.addEventListener('beforeunload', securityHandler);
        isGlobalHandlerRegistered = true;
    }
}
function unregisterGlobalHandler() {
    if (isGlobalHandlerRegistered && instances.length === 0) {
        window.removeEventListener('beforeunload', securityHandler);
        isGlobalHandlerRegistered = false;
    }
}
class SecurityHandler {
    constructor(predicate = null) {
        this.isEnabled = true;
        this.predicate = () => true;
        if (predicate !== null) {
            this.predicate = predicate;
        }
    }
    setPredicate(predicate) {
        this.predicate = predicate;
    }
    shouldWarn() {
        return this.isEnabled && this.predicate();
    }
    enable() {
        this.isEnabled = true;
    }
    disable() {
        this.isEnabled = false;
    }
    toggle(state = null) {
        this.isEnabled = state ?? !this.isEnabled;
    }
}
export function useSecurityHandler(predicate = null, standalone = false) {
    const instance = new SecurityHandler(predicate);
    instances.push(instance);
    if (!standalone) {
        onBeforeMount(() => registerGlobalHandler());
        onUnmounted(() => {
            instances = instances.filter((i) => instance !== i);
            unregisterGlobalHandler();
        });
    }
    return {
        setPredicate(predicate) {
            instance.setPredicate(predicate);
        },
        toggle(state = null) {
            instance.toggle(state);
        },
        activate() {
            instance.toggle(true);
        },
        deactivate() {
            instance.toggle(false);
        },
        registerGlobalHandler,
        unregisterGlobalHandler
    };
}
